/**
 * Validates that required VITE_* environment variables are set at app startup.
 * Throws an error listing all missing variables so misconfigurations are caught
 * immediately rather than silently at the point of use.
 *
 * Only runs outside of test environments.
 */

const REQUIRED_ENV_VARS = [
  'VITE_BACKEND_URL',
  'VITE_AUTH_URL',
  'VITE_AZURE_CLIENT_ID',
  'VITE_GOOGLE_CLIENT_ID',
  'VITE_PUBLIC_POSTHOG_PROJECT_TOKEN',
  'VITE_PUBLIC_POSTHOG_HOST',
] as const

export function validateEnv(): void {
  if (import.meta.env.MODE === 'test') {
    return
  }

  const missing = REQUIRED_ENV_VARS.filter(
    (key) => !import.meta.env[key],
  )

  if (missing.length === 0) {
    return
  }

  const message = [
    'Missing required environment variables:',
    ...missing.map((key) => `  - ${key}`),
    '',
    'Ensure these are set in the appropriate .env file before starting the app.',
  ].join('\n')

  // Log clearly so the error is visible in the browser console even if
  // something catches the thrown error downstream.
  console.error(message)
  throw new Error(message)
}
